import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.fabricWebLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.FabricWebLabel),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.FabricWebLabel)
    ]
})
export class FabricWebLinkedService extends LinkedService { }
